import gql from 'graphql-tag';

export default gql`
    mutation($organizationId: String!, $id: String!, $alias: String!, $otpToken: String!, $ips: [String!]!, $rules: String!, $readOnly: Boolean!) {
        updateApiKeys(organizationId: $organizationId, id: $id, alias: $alias, otpToken: $otpToken, ips: $ips, rules: $rules, readOnly: $readOnly)
    }
`;
